import React from 'react';
import UserManagement from '../../../components/UserManagement/UserManagement';

const UsersRolesManagement = () => {
  return <UserManagement />;
};

export default UsersRolesManagement;